import { render } from "./AdminDateTime.vue?vue&type=template&id=ddaaef88"
import script from "./AdminDateTime.vue?vue&type=script&lang=js"
export * from "./AdminDateTime.vue?vue&type=script&lang=js"

import "./AdminDateTime.vue?vue&type=style&index=0&id=ddaaef88&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__